import React, { useState } from "react";
import "../../commoncss/ChatRoom.css";
import { IoCloseCircle } from "react-icons/io5";
import { FaPlus } from "react-icons/fa6";
import { IoCloseOutline } from "react-icons/io5";
import { RiSendPlaneLine } from "react-icons/ri";
import { BsBell, BsBellSlash } from "react-icons/bs";
import { FaReply, FaShare } from "react-icons/fa";
import { BiDotsVerticalRounded } from "react-icons/bi";
import { IoSearch } from "react-icons/io5";
import Cookies from "universal-cookie";
import { useEffect } from "react";
import { useSocket } from "../../contexts/SocketContext";
import { useRef } from "react";
import { useNotifications } from "../../hooks/useNotifications";
import NotificationSettings from "../../commoncomponents/NotificationSettings";

const ChatRoom = (props) => {
  const [activeRoom, setActiveRoom] = useState("");
  const [liveRoom, setLiveRoom] = useState({ name: "", id: "", member: [] });
  const cookie = new Cookies();
  const [getRoomList, setRoomList] = useState([]);
  const [getMessageListOld, setMessageListOld] = useState([]);
  const [getId, setId] = useState("");
  const [getNotifyList, setNotifyList] = useState({});
  const [selectedImage, setSelectedImage] = useState(null);
  const [getUploadDoc, setUploadDoc] = useState({});
  const [getFileName, setFileName] = useState("");
  const [imagePreview, setImagePreview] = useState("");
  const [showNotificationSettings, setShowNotificationSettings] = useState(false);

  // Reply and Forward state
  const [replyingTo, setReplyingTo] = useState(null);
  const [messageMenus, setMessageMenus] = useState({});
  const [showForwardModal, setShowForwardModal] = useState(false);
  const [forwardingMessage, setForwardingMessage] = useState(null);
  const [forwardSearchTerm, setForwardSearchTerm] = useState("");
  const [selectedForwardRooms, setSelectedForwardRooms] = useState([]);
  const [showMembersModal, setShowMembersModal] = useState(false);
  const [isLoadingOlderMessages, setIsLoadingOlderMessages] = useState(false);
  const [lastScrollTop, setLastScrollTop] = useState(0);
  const [imageZoom, setImageZoom] = useState(1);
  const [imagePosition, setImagePosition] = useState({ x: 0, y: 0 });
  const [isDragging, setIsDragging] = useState(false);
  const [dragStart, setDragStart] = useState({ x: 0, y: 0 });
  const [highlightedMessageId, setHighlightedMessageId] = useState(null);
  const imageModalRef = useRef(null);
  const [isImageSending, setIsImageSending] = useState(false);

  // Tagging/Mention state
  const [showMentionSuggestions, setShowMentionSuggestions] = useState(false);
  const [mentionSearchTerm, setMentionSearchTerm] = useState("");
  const [mentionSuggestions, setMentionSuggestions] = useState([]);
  const [currentCursorPosition, setCurrentCursorPosition] = useState(0);
  const [taggedUsers, setTaggedUsers] = useState([]);

  const { socket, isConnected, emit, on } = useSocket();
  const {
    showNotificationIfInactive,
    isEnabled: notificationsEnabled,
    initialize: initializeNotifications
  } = useNotifications();

  useEffect(() => {
    if (!socket || !isConnected) return;

    // Listen to events
    const cleanup1 = on("messageReceived", (data) => {
      console.log("Message received:", data);
    });

    const cleanup2 = on("userJoined", (data) => {
      console.log("User joined:", data);
    });

    // Cleanup listeners when component unmounts
    return () => {
      cleanup1?.();
      cleanup2?.();
    };
  }, [socket, isConnected, on]);

  useEffect(() => {
    // if (!socket || !isConnected) return;

    const cleanupReceiveMessage = on("receiveMessage", (data) => {
      console.log("Received message:", data);
      
      // Only add message to current message list if it belongs to the active room
      if (data.to === activeRoom) {
        setMessageListOld((prevList) => [...prevList, data]);

        // Smooth scroll to bottom when new message is received
        setTimeout(() => {
          scrollToBottom(false);
        }, 100);
      }

      if (data.from !== getId) {
        setNotifyList((prev) => {
          return {
            ...prev,
            [data.to]: (prev[data.to] || 0) + 1,
          };
        });

        // Show browser notification if tab is not active
        const currentRoom = getRoomList.find(room => room.id === data.to);
        const senderName = currentRoom?.names?.[data.from] || (data.from === getId ? 'You' : 'Unknown User');
        
        // Check if current user is mentioned in the message
        const currentUserName = currentRoom?.names?.[getId] || 'You';
        const isMentioned = data.data && typeof data.data === 'string' && 
                           data.data.toLowerCase().includes(`@${currentUserName.toLowerCase()}`);

        showNotificationIfInactive(data, {
          roomName: currentRoom?.name || 'Chat Room',
          senderName: senderName,
          roomNames: currentRoom?.names || {},
          currentUserId: getId,
          isMentioned: isMentioned, // Pass mention status for enhanced notification
          priority: isMentioned ? 'high' : 'normal' // Higher priority for mentions
        });
      }
    });

    // Cleanup listener when component unmounts or socket disconnects
    return () => {
      cleanupReceiveMessage?.();
    };
  }, [socket, isConnected, on]);

  // Initialize notifications
  useEffect(() => {
    initializeNotifications();
  }, [initializeNotifications]);

  // Listen for notification clicks to switch rooms
  useEffect(() => {
    const handleNotificationClick = (event) => {
      const { roomId } = event.detail;
      if (roomId) {
        setActiveRoom(roomId);
        const room = getRoomList.find(r => r.id === roomId);
        if (room) {
          setLiveRoom(room);
        }
      }
    };

    window.addEventListener('notificationClick', handleNotificationClick);
    return () => {
      window.removeEventListener('notificationClick', handleNotificationClick);
    };
  }, [getRoomList]);

  const divRef = useRef(null);

  const scrollToBottom = (instant = false) => {
    if (divRef.current) {
      if (instant) {
        // Instant scroll without animation
        divRef.current.scrollTop = divRef.current.scrollHeight;
      } else {
        // Smooth scroll for new messages
        divRef.current.scrollTo({
          top: divRef.current.scrollHeight,
          behavior: 'smooth'
        });
      }
    }
  };

  const handleScroll = () => {
    const div = divRef.current;
    if (!div) return;

    const scrollTop = div.scrollTop;
    const clientHeight = div.clientHeight;
    const scrollHeight = div.scrollHeight;

    const threshold = 50; // increased threshold for better UX

    // Throttle scroll events and prevent loading when already loading
    if (scrollTop <= threshold && !isLoadingOlderMessages && scrollTop < lastScrollTop) {
      setIsLoadingOlderMessages(true);
      get_chat_before(liveRoom.id);
      console.log("Reached the TOP of the div");
    } else if (scrollTop + clientHeight >= scrollHeight - threshold) {
      console.log("Reached the BOTTOM of the div");
      get_chat_after(liveRoom.id);
      seen_till(liveRoom.id);
      setNotifyList((prev) => {
        return {
          ...prev,
          [liveRoom.id]: 0,
        };
      });
    }

    setLastScrollTop(scrollTop);
  };


  const formatTime = (timestamp) => {
    const d = new Date(timestamp);
    const h = d.getHours();
    const m = d.getMinutes();
    const hours12 = ((h + 11) % 12) + 1;
    const ampm = h >= 12 ? "PM" : "AM";
    const paddedMinutes = m < 10 ? "0" + m : m;
    return `${hours12}:${paddedMinutes} ${ampm}`;
  };

  const toBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = reject;
    });

  const compressImage = (file, maxWidth = 1920, maxHeight = 1080, quality = 0.8) => {
    return new Promise((resolve) => {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      const img = new Image();

      img.onload = () => {
        // Calculate new dimensions
        let { width, height } = img;

        if (width > maxWidth || height > maxHeight) {
          const aspectRatio = width / height;

          if (width > height) {
            width = maxWidth;
            height = maxWidth / aspectRatio;
          } else {
            height = maxHeight;
            width = maxHeight * aspectRatio;
          }
        }

        canvas.width = width;
        canvas.height = height;

        // Draw and compress
        ctx.drawImage(img, 0, 0, width, height);
        const compressedDataUrl = canvas.toDataURL('image/jpeg', quality);
        resolve(compressedDataUrl);
      };

      img.src = URL.createObjectURL(file);
    });
  };

  const select_file_upload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // Check file size (10MB limit for original file)
    const maxFileSize = 10 * 1024 * 1024; // 10MB
    if (file.size > maxFileSize) {
      alert('File size too large. Please select an image under 10MB.');
      e.target.value = ''; // Clear the input
      return;
    }

    try {
      const arr = file.name.split(".");
      const sizearr = arr.length;

      // Compress image if it's too large
      let dataset;
      if (file.size > 2 * 1024 * 1024) { // If larger than 2MB, compress
        dataset = await compressImage(file);
      } else {
        dataset = await toBase64(file);
      }

      // Check final base64 size (should be under 10MB for MongoDB)
      const base64Size = dataset.length * 0.75; // Approximate base64 to binary size
      if (base64Size > 8 * 1024 * 1024) { // 8MB limit for safety
        // Try with higher compression
        dataset = await compressImage(file, 1280, 720, 0.6);

        const finalSize = dataset.length * 0.75;
        if (finalSize > 8 * 1024 * 1024) {
          alert('Image is too large even after compression. Please select a smaller image.');
          e.target.value = '';
          return;
        }
      }

      const setme = {
        ext: 'jpg', // Always use jpg for compressed images
        data: dataset.split(",")[1],
        name: file.name,
      };

      setFileName(file.name);
      setUploadDoc(setme);
      setImagePreview(dataset);

    } catch (error) {
      console.error('Error processing image:', error);
      alert('Error processing image. Please try a different file.');
      e.target.value = '';
    }
  };

  const processClipboardFile = async (file) => {
    try {
      const timestamp = new Date().getTime();
      const fileName = `clipboard_image_${timestamp}.jpg`;

      // Always compress clipboard images
      const dataset = await compressImage(file, 1920, 1080, 0.8);

      // Check size
      const base64Size = dataset.length * 0.75;
      if (base64Size > 8 * 1024 * 1024) {
        alert('Clipboard image is too large. Please copy a smaller image.');
        return;
      }

      const setme = {
        ext: 'jpg',
        data: dataset.split(",")[1],
        name: fileName,
      };

      setFileName(fileName);
      setUploadDoc(setme);
      setImagePreview(dataset);

    } catch (error) {
      console.error('Error processing clipboard image:', error);
      alert('Error processing clipboard image.');
    }
  };


  const get_rooms = async () => {
    try {
      // setLoading(true);
      const resp = await fetch(`${process.env.REACT_APP_URL}/admin/getrooms`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
        body: JSON.stringify({ token: cookie.get("admin") }),
      });
      if (resp.status === 200) {
        const dataset = await resp.json();
        if (dataset.status === true) {
          setRoomList(dataset.data.data);
          let obj = {};
          for (let i = 0; i < dataset.data.data.length; i++) {
            obj[dataset.data.data[i].id] = dataset.data.data[i].unread;
          }
          console.log(obj, "obj here");
          setNotifyList({ ...obj });
          setId(dataset.data.id);
          for (let i = 0; i < dataset.data.data.length; i++) {
            emit("joinRoom", { room: dataset.data.data[i].id });
          }
        } else {
          // showToast("Failed to fetch search results", "error");
        }
      } else {
        // showToast("Request failed, try again", "error");
      }
    } catch (error) {
      console.log("Error fetching search results for data details", error);
      // showToast(
      //   "Network error occured while fetching data details, please try again later",
      //   "error"
      // );
    } finally {
      // setLoading(false);
    }
  };

  const send_message = async () => {
    try {
      console.log("send_message called", { activeRoom, fileName: getFileName, liveRoomId: liveRoom.id });
      
      // Check if a room is selected
      if (!activeRoom || activeRoom === "" || !liveRoom.id) {
        console.log("No room selected");
        alert("Please select a room before sending a message.");
        return;
      }

      let tempp = {};
      const messageInput = document.getElementById("messagehere");
      const messageText = messageInput ? messageInput.value : "";
      
      console.log("Message text:", messageText, "File name:", getFileName);
      
      // Validate that there's either a message or a file to send
      if (getFileName === "" && (!messageText || messageText.trim() === "")) {
        console.log("No message or file to send");
        alert("Please enter a message or select an image to send.");
        return;
      }
      
      if (getFileName == "") {
        // Process mentions in the message
        const mentionedUsers = processMessageForTags(messageText);
        
        tempp = {
          data: messageText,
          file: false,
          room: liveRoom.id,
          originalMessage: replyingTo || null,
          mentionedUsers: mentionedUsers.map(mention => mention.id), // Send array of mentioned user IDs
        };
      } else {
        console.log("Sending image upload:", { 
          fileName: getFileName, 
          uploadDoc: getUploadDoc, 
          roomId: liveRoom.id 
        });
        
        // Set loading state for image sending
        setIsImageSending(true);
        
        tempp = {
          file: true,
          room: liveRoom.id,
          ...getUploadDoc,
          originalMessage: replyingTo || null,
          mentionedUsers: [], // No mentions for file messages
        };
      }
      const resp = await fetch(
        `${process.env.REACT_APP_URL}/admin/sendmessage`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json; charset=UTF-8",
          },
          body: JSON.stringify({
            token: cookie.get("admin"),
            ...tempp,
          }),
        }
      );
      if (resp.status == 200) {
        const dataset = await resp.json();
        if (dataset.status == true) {
          console.log("Message sent successfully:", dataset);
          // get_chat(liveRoom.id);
          get_chat_old(liveRoom.id);
          setUploadDoc({})
          setFileName("")
          setImagePreview("");
          setIsImageSending(false); // Clear loading state
          const messageInput = document.getElementById("messagehere");
          if (messageInput) {
            messageInput.value = "";
          }
          setReplyingTo(null);
          
          // Clear tagging state
          setTaggedUsers([]);
          setShowMentionSuggestions(false);
          setMentionSearchTerm('');

          // Smooth scroll to bottom after sending message
          setTimeout(() => {
            scrollToBottom(false);
          }, 200);
        } else {
          console.error("Server responded with error:", dataset);
          setIsImageSending(false); // Clear loading state
          alert("Failed to send message. Please try again.");
        }
      } else {
        console.error("HTTP error:", resp.status);
        const errorText = await resp.text();
        console.error("Error response:", errorText);
        setIsImageSending(false); // Clear loading state
        alert("Network error. Please check your connection and try again.");
      }
    } catch (error) {
      console.error("Error sending message:", error);
      setIsImageSending(false); // Clear loading state
      alert("An error occurred while sending the message. Please try again.");
    }
  };

  const get_chat_old = async (id) => {
    try {
      const resp = await fetch(
        `${process.env.REACT_APP_URL}/admin/getmessageold`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json; charset=UTF-8",
          },
          body: JSON.stringify({
            token: cookie.get("admin"),
            room: id,
          }),
        }
      );

      if (resp.status == 200) {
        const dataset = await resp.json();
        if (dataset.status == true) {
          setMessageListOld(dataset.data.data);
          // Instant scroll to bottom for initial load - no animation
          requestAnimationFrame(() => {
            scrollToBottom(true);
          });
        }
      }
    } catch (error) {
      console.log(error);
    }
  };



  const openImageModal = (imageUrl) => {
    setSelectedImage(imageUrl);
  };

  const closeImageModal = () => {
    setSelectedImage(null);
    setImageZoom(1);
    setImagePosition({ x: 0, y: 0 });
    setIsDragging(false);
  };

  // Handle keyboard close (Escape key)
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape' && selectedImage) {
        closeImageModal();
      }
    };

    if (selectedImage) {
      document.addEventListener('keydown', handleKeyDown);
      return () => document.removeEventListener('keydown', handleKeyDown);
    }
  }, [selectedImage]);

  const handleImageWheel = (e) => {
    e.preventDefault();

    const container = e.currentTarget;
    const rect = container.getBoundingClientRect();

    // Get mouse position relative to container center
    const mouseX = e.clientX - rect.left - rect.width / 2;
    const mouseY = e.clientY - rect.top - rect.height / 2;

    // Calculate zoom increment (smaller for finer control)
    const delta = e.deltaY > 0 ? -0.2 : 0.2;
    const newZoom = Math.min(Math.max(imageZoom + delta, 0.3), 8);

    if (newZoom !== imageZoom) {
      if (newZoom <= 1) {
        // Reset to center when zooming to 1x or below
        setImageZoom(newZoom);
        setImagePosition({ x: 0, y: 0 });
      } else {
        // Calculate position to keep mouse point fixed
        const zoomRatio = newZoom / imageZoom;
        const currentMouseX = mouseX - imagePosition.x;
        const currentMouseY = mouseY - imagePosition.y;

        const newX = mouseX - currentMouseX * zoomRatio;
        const newY = mouseY - currentMouseY * zoomRatio;

        setImageZoom(newZoom);
        setImagePosition({ x: newX, y: newY });
      }
    }
  };

  const handleImageMouseDown = (e) => {
    if (imageZoom > 1) {
      e.preventDefault();
      setIsDragging(true);
      setDragStart({
        x: e.clientX - imagePosition.x,
        y: e.clientY - imagePosition.y
      });

      // Disable image transitions during drag
      if (imageModalRef.current) {
        imageModalRef.current.style.transition = 'none';
      }
    }
  };

  const handleImageMouseMove = (e) => {
    if (isDragging && imageZoom > 1) {
      e.preventDefault();
      const newX = e.clientX - dragStart.x;
      const newY = e.clientY - dragStart.y;

      setImagePosition({ x: newX, y: newY });
    }
  };

  const handleImageMouseUp = () => {
    setIsDragging(false);

    // Re-enable transitions after drag
    if (imageModalRef.current) {
      imageModalRef.current.style.transition = 'transform 0.1s ease-out';
    }
  };

  const zoomIn = () => {
    const newZoom = Math.min(imageZoom + 0.3, 8);
    if (newZoom <= 1) {
      setImageZoom(newZoom);
      setImagePosition({ x: 0, y: 0 });
    } else {
      setImageZoom(newZoom);
    }
  };

  const zoomOut = () => {
    const newZoom = Math.max(imageZoom - 0.3, 0.3);
    if (newZoom <= 1) {
      setImageZoom(newZoom);
      setImagePosition({ x: 0, y: 0 });
    } else {
      setImageZoom(newZoom);
    }
  };

  const resetZoom = () => {
    setImageZoom(1);
    setImagePosition({ x: 0, y: 0 });
  };

  const get_chat_before = async (id) => {
    try {
      if (!getMessageListOld.length) {
        setIsLoadingOlderMessages(false);
        return;
      }

      const div = divRef.current;
      const prevScrollHeight = div ? div.scrollHeight : 0;

      const resp = await fetch(
        `${process.env.REACT_APP_URL}/admin/beforemessage`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json; charset=UTF-8",
          },
          body: JSON.stringify({
            token: cookie.get("admin"),
            room: id,
            message: getMessageListOld[0].id,
          }),
        }
      );

      if (resp.status == 200) {
        const dataset = await resp.json();
        if (dataset.status == true && dataset.data.data.length > 0) {
          setMessageListOld((prevList) => [...dataset.data.data, ...prevList]);

          // Preserve scroll position after new messages are added
          setTimeout(() => {
            if (div) {
              const newScrollHeight = div.scrollHeight;
              const heightDifference = newScrollHeight - prevScrollHeight;
              div.scrollTop = div.scrollTop + heightDifference;
            }
            setIsLoadingOlderMessages(false);
          }, 100);
        } else {
          setIsLoadingOlderMessages(false);
        }
      } else {
        setIsLoadingOlderMessages(false);
      }
    } catch (error) {
      console.log(error);
      setIsLoadingOlderMessages(false);
    }
  };

  const get_chat_after = async (id) => {
    try {
      const resp = await fetch(
        `${process.env.REACT_APP_URL}/admin/aftermessage`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json; charset=UTF-8",
          },
          body: JSON.stringify({
            token: cookie.get("admin"),
            room: id,
            message: getMessageListOld[getMessageListOld.length - 1].id,
          }),
        }
      );

      if (resp.status == 200) {
        const dataset = await resp.json();
        if (dataset.status == true) {
          setMessageListOld((prevList) => [...prevList, ...dataset.data.data]);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const seen_till = async (id) => {
    try {
      const resp = await fetch(`${process.env.REACT_APP_URL}/admin/seen`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
        body: JSON.stringify({
          token: cookie.get("admin"),
          room: id,
          message: getMessageListOld[getMessageListOld.length - 1].id,
        }),
      });

      if (resp.status == 200) {
        const dataset = await resp.json();
        if (dataset.status == true) {
          console.log("seen");
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  function uuidToHex(uuid) {
    // Create hash from UUID
    let hash = 0;
    for (let i = 0; i < uuid.length; i++) {
      const char = uuid.charCodeAt(i);
      hash = ((hash << 5) - hash) + char;
      hash = hash & hash; // Convert to 32-bit integer
    }

    // Generate HSL values for better color distribution
    const hue = Math.abs(hash) % 360;
    const saturation = 60 + (Math.abs(hash >> 8) % 30); // 60-90%
    const lightness = 45 + (Math.abs(hash >> 16) % 20);  // 45-65%

    // Convert HSL to RGB
    const s = saturation / 100;
    const l = lightness / 100;
    const c = (1 - Math.abs(2 * l - 1)) * s;
    const x = c * (1 - Math.abs((hue / 60) % 2 - 1));
    const m = l - c / 2;

    let r = 0, g = 0, b = 0;

    if (0 <= hue && hue < 60) {
      r = c; g = x; b = 0;
    } else if (60 <= hue && hue < 120) {
      r = x; g = c; b = 0;
    } else if (120 <= hue && hue < 180) {
      r = 0; g = c; b = x;
    } else if (180 <= hue && hue < 240) {
      r = 0; g = x; b = c;
    } else if (240 <= hue && hue < 300) {
      r = x; g = 0; b = c;
    } else if (300 <= hue && hue < 360) {
      r = c; g = 0; b = x;
    }

    // Convert to hex
    const red = Math.round((r + m) * 255);
    const green = Math.round((g + m) * 255);
    const blue = Math.round((b + m) * 255);

    return `#${red.toString(16).padStart(2, '0')}${green.toString(16).padStart(2, '0')}${blue.toString(16).padStart(2, '0')}`;
  }

  // Tagging/Mention helper functions
  const handleMentionInput = (e) => {
    const value = e.target.value;
    const cursorPosition = e.target.selectionStart;
    setCurrentCursorPosition(cursorPosition);

    // Find @ symbol before cursor
    const textBeforeCursor = value.substring(0, cursorPosition);
    const lastAtSymbol = textBeforeCursor.lastIndexOf('@');
    
    if (lastAtSymbol !== -1) {
      const textAfterAt = textBeforeCursor.substring(lastAtSymbol + 1);
      
      // Check if we're still in a mention (no space after @)
      if (!textAfterAt.includes(' ') && textAfterAt.length >= 0) {
        setMentionSearchTerm(textAfterAt.toLowerCase());
        updateMentionSuggestions(textAfterAt.toLowerCase());
        setShowMentionSuggestions(true);
        return;
      }
    }
    
    // Hide suggestions if not typing a mention
    setShowMentionSuggestions(false);
    setMentionSearchTerm('');
  };

  const updateMentionSuggestions = (searchTerm) => {
    if (!liveRoom.member || !liveRoom.names) return;
    
    const suggestions = liveRoom.member
      .filter(memberId => {
        const memberName = liveRoom.names[memberId] || (memberId === 'admin' ? 'ADMIN' : 'Unknown');
        return memberId !== getId && // Don't suggest self
               memberName.toLowerCase().includes(searchTerm);
      })
      .map(memberId => ({
        id: memberId,
        name: liveRoom.names[memberId] || (memberId === 'admin' ? 'ADMIN' : 'Unknown')
      }))
      .slice(0, 5); // Limit to 5 suggestions
    
    setMentionSuggestions(suggestions);
  };

  const selectMention = (suggestion) => {
    const messageInput = document.getElementById("messagehere");
    const currentValue = messageInput.value;
    const textBeforeCursor = currentValue.substring(0, currentCursorPosition);
    const textAfterCursor = currentValue.substring(currentCursorPosition);
    const lastAtSymbol = textBeforeCursor.lastIndexOf('@');
    
    if (lastAtSymbol !== -1) {
      const beforeAt = textBeforeCursor.substring(0, lastAtSymbol);
      const newValue = `${beforeAt}@${suggestion.name} ${textAfterCursor}`;
      messageInput.value = newValue;
      
      // Add to tagged users
      setTaggedUsers(prev => {
        const existingTag = prev.find(tag => tag.id === suggestion.id);
        if (existingTag) return prev;
        return [...prev, suggestion];
      });
      
      // Position cursor after the mention
      const newCursorPosition = lastAtSymbol + suggestion.name.length + 2;
      setTimeout(() => {
        messageInput.focus();
        messageInput.setSelectionRange(newCursorPosition, newCursorPosition);
      }, 0);
    }
    
    setShowMentionSuggestions(false);
    setMentionSearchTerm('');
  };

  const processMessageForTags = (message) => {
    const mentionRegex = /@([a-zA-Z0-9_]+)(?=\s|$)/g;
    const mentions = [];
    let match;
    
    while ((match = mentionRegex.exec(message)) !== null) {
      const mentionName = match[1];
      // Find user by name
      const mentionedUser = liveRoom.member?.find(memberId => {
        const memberName = liveRoom.names?.[memberId] || (memberId === 'admin' ? 'ADMIN' : 'Unknown');
        return memberName.toLowerCase() === mentionName.toLowerCase();
      });
      
      if (mentionedUser) {
        mentions.push({
          id: mentionedUser,
          name: mentionName,
          start: match.index,
          end: match.index + match[0].length
        });
      }
    }
    
    return mentions;
  };

  const isCurrentUserTagged = (messageText) => {
    if (!messageText || !liveRoom.names?.[getId]) return false;
    
    const currentUserName = liveRoom.names[getId];
    const mentionRegex = /@([a-zA-Z0-9_]+)(?=\s|$)/g;
    let match;
    
    while ((match = mentionRegex.exec(messageText)) !== null) {
      const mentionName = match[1];
      if (mentionName.toLowerCase() === currentUserName.toLowerCase()) {
        return true;
      }
    }
    
    return false;
  };

  const isAnyUserTagged = (messageText) => {
    if (!messageText) return false;
    
    const mentionRegex = /@([a-zA-Z0-9_]+)(?=\s|$)/g;
    const result = mentionRegex.test(messageText);
    
    
    return result;
  };

  const renderMessageWithTags = (messageText, messageId) => {
    if (!messageText) return messageText;
    
    
    const mentionRegex = /@([a-zA-Z0-9_]+)(?=\s|$)/g;
    const parts = [];
    let lastIndex = 0;
    let match;
    
    while ((match = mentionRegex.exec(messageText)) !== null) {
      console.log('Admin - Found mention in message:', {
        messageText,
        mentionFound: match[1],
        messageId
      });
      
      // Add text before mention
      if (match.index > lastIndex) {
        parts.push(messageText.substring(lastIndex, match.index));
      }
      
      // Add mention with styling
      const mentionName = match[1];
      const isCurrentUserMentioned = liveRoom.names?.[getId] && 
                                   liveRoom.names[getId].toLowerCase() === mentionName.toLowerCase();
      
      // Find the mentioned user ID to get their hex color
      const mentionedUserId = liveRoom.member?.find(memberId => {
        const memberName = liveRoom.names?.[memberId] || (memberId === 'admin' ? 'ADMIN' : 'Unknown');
        return memberName.toLowerCase() === mentionName.toLowerCase();
      });
      
      // Get hex color for the mentioned user
      const mentionBackgroundColor = mentionedUserId ? uuidToHex(mentionedUserId) : '#6366f1';
      
      
      
      parts.push(
        <span 
          key={`${messageId}-mention-${match.index}`}
          className={`mention-tag ${isCurrentUserMentioned ? 'mention-self' : ''}`}
          style={{
            backgroundColor: mentionBackgroundColor,
            color: 'white'
          }}
        >
          @{mentionName}
        </span>
      );
      
      lastIndex = match.index + match[0].length;
    }
    
    // Add remaining text
    if (lastIndex < messageText.length) {
      parts.push(messageText.substring(lastIndex));
    }
    
    return parts.length > 1 ? parts : messageText;
  };

  useEffect(() => {
    get_rooms();
    get_chat_old();
  }, [""]);

  // functionality to close message menus when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      setMessageMenus({});
      
      // Close mention suggestions if clicking outside
      if (!event.target.closest('.mention-suggestions-dropdown') && 
          !event.target.closest('#messagehere')) {
        setShowMentionSuggestions(false);
        setMentionSearchTerm('');
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  // Handle clipboard paste for images
  useEffect(() => {
    const handlePaste = async (e) => {
      const clipboardItems = e.clipboardData.items;

      for (let i = 0; i < clipboardItems.length; i++) {
        const item = clipboardItems[i];

        if (item.type.indexOf("image") !== -1) {
          e.preventDefault();
          const file = item.getAsFile();

          if (file) {
            console.log('Image pasted from clipboard:', file);
            await processClipboardFile(file);
          }
          break;
        }
      }
    };

    document.addEventListener("paste", handlePaste);
    return () => document.removeEventListener("paste", handlePaste);
  }, []);

  // Handle Enter key for sending images when image is uploaded
  useEffect(() => {
    const handleKeyDown = (e) => {
      // Only trigger if an image is selected and we're in an active room
      if (e.key === 'Enter' && activeRoom !== "" && getFileName !== "") {
        // Only trigger if an image is selected and we're in an active room
        // Text messages are handled by the input field's onKeyDown
        e.preventDefault();
        console.log("Global Enter key pressed for image send");
        send_message();
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [activeRoom, getFileName]);

  const handleUploadClick = () => {
    document.getElementById("file-input").click();
  };

  const clearUploadedFile = () => {
    setFileName("");
    setUploadDoc({});
    setImagePreview("");
    setIsImageSending(false);
    document.getElementById("file-input").value = "";
  };

  // Reply and Forward handlers
  const toggleMessageMenu = (messageId) => {
    setMessageMenus((prev) => ({
      ...prev,
      [messageId]: !prev[messageId],
    }));
  };

  const handleReply = (message) => {
    setReplyingTo(message);
    setMessageMenus({});
    document.getElementById("messagehere").focus();
  };

  const cancelReply = () => {
    setReplyingTo(null);
  };

  const scrollToMessage = async (messageId) => {
    // First, try to find the message in current DOM
    let messageElement = document.querySelector(`[data-message-id="${messageId}"]`);

    if (messageElement && divRef.current) {
      // Message is already in DOM, just scroll to it
      const containerRect = divRef.current.getBoundingClientRect();
      const messageRect = messageElement.getBoundingClientRect();
      const scrollTop = divRef.current.scrollTop;
      const targetScroll = scrollTop + messageRect.top - containerRect.top - (containerRect.height / 2) + (messageRect.height / 2);

      divRef.current.scrollTo({
        top: targetScroll,
        behavior: 'smooth'
      });

      setHighlightedMessageId(messageId);
      setTimeout(() => setHighlightedMessageId(null), 2000);
      return;
    }

    // Message not in DOM, load messages around the target message
    setIsLoadingOlderMessages(true);

    try {
      const response = await fetch(`${process.env.REACT_APP_URL}/admin/messagesaroundtarget`, {
        method: "POST",
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${cookie.get("adminToken")}`
        },
        body: JSON.stringify({
          token: cookie.get("admin"),
          room: liveRoom.id,
          target_message_id: messageId
        })
      });

      const result = await response.json();

      if (result.status) {
        // Replace current message list with the new messages centered around target
        setMessageListOld(result.data.data);

        // Wait for DOM to render the new messages
        await new Promise(resolve => setTimeout(resolve, 300));

        // Now try to scroll to the target message
        messageElement = document.querySelector(`[data-message-id="${messageId}"]`);

        if (messageElement && divRef.current) {
          // Scroll to target without smooth animation initially to position correctly
          const containerRect = divRef.current.getBoundingClientRect();
          const messageRect = messageElement.getBoundingClientRect();
          const scrollTop = divRef.current.scrollTop;
          const targetScroll = scrollTop + messageRect.top - containerRect.top - (containerRect.height / 2) + (messageRect.height / 2);

          // Set position without animation first
          divRef.current.scrollTop = targetScroll;

          // Wait a moment then do smooth highlight
          await new Promise(resolve => setTimeout(resolve, 100));

          setHighlightedMessageId(messageId);
          setTimeout(() => setHighlightedMessageId(null), 2000);
        }
      } else {
        console.error('Failed to load messages around target:', result.error);
      }
    } catch (error) {
      console.error('Error calling messagesaroundtarget API:', error);
    } finally {
      setIsLoadingOlderMessages(false);
    }
  };

  const handleForward = (message) => {
    setForwardingMessage(message);
    setShowForwardModal(true);
    setMessageMenus({});
  };

  const handleForwardSend = () => {
    for (let i = 0; i < selectedForwardRooms.length; i++) {
      forward_message(selectedForwardRooms[i]);
    }
    setShowForwardModal(false);
    setForwardingMessage(null);
    setSelectedForwardRooms([]);
    setForwardSearchTerm("");
  };

  const forward_message = async (room) => {
    try {
      let tempp = {
        ...forwardingMessage,
        room: room
      };
      const resp = await fetch(`${process.env.REACT_APP_URL}/admin/sendmessage`, {
        method: "POST",
        headers: { "Content-Type": "application/json; charset=UTF-8" },
        body: JSON.stringify({ token: cookie.get("admin"), ...tempp }),
      });
      if (resp.status == 200) {
        const dataset = await resp.json();
        if (dataset.status == true) {
          console.log("Message forwarded successfully");
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const closeForwardModal = () => {
    setShowForwardModal(false);
    setForwardingMessage(null);
    setSelectedForwardRooms([]);
    setForwardSearchTerm("");
  };

  const toggleRoomSelection = (roomId) => {
    setSelectedForwardRooms((prev) =>
      prev.includes(roomId)
        ? prev.filter((id) => id !== roomId)
        : [...prev, roomId]
    );
  };

  // Helper functions for reply display
  const renderEnhancedReplyIndicator = (message) => {
    if (!message.reply_to) return null;

    const originalMessage = message.reply_to;
    const isImageReply = originalMessage?.file;
    const originalSender = originalMessage?.from === getId ?
      'You' : (liveRoom.names?.[originalMessage?.from] || 'ADMIN');

    const handleReplyClick = () => {
      if (originalMessage?.id) {
        scrollToMessage(originalMessage.id);
      }
    };

    return (
      <div className="enhanced_reply_indicator">
        <div className="reply_line"></div>
        <div className="reply_content_enhanced">
          <div className="reply_header">
            <span className="reply_sender">{originalSender}</span>
            <span className="reply_timestamp">
              {originalMessage ? formatTime(originalMessage.sent_at) : ''}
            </span>
          </div>
          <div className="original_message_display" onClick={handleReplyClick} style={{ cursor: 'pointer' }} title="Click to view original message">
            {isImageReply ? (
              <div className="original_image_preview">
                <img src={`data:image/${originalMessage.ext};base64, ${originalMessage.data}`} />
                <span className="original_image_label">📷 Original Image</span>
              </div>
            ) : (
              <p className="reply_text_enhanced">{originalMessage?.data || 'Message not found'}</p>
            )}
          </div>
        </div>
      </div>
    );
  };

  const getReplyCount = (messageId) => {
    return getMessageListOld.filter(msg => msg.reply_to && msg.reply_to.id === messageId).length;
  };

  const renderEnhancedMessageActions = (message) => {
    return (
      <div className="message_actions_enhanced">
        <div className="message_menu_trigger" onClick={(event) => {
          event.stopPropagation();
          toggleMessageMenu(message.id);
        }}>
          <BiDotsVerticalRounded />
        </div>
        {messageMenus[message.id] && (
          <div className="message_menu">
            <div className="menu_item" onClick={() => handleReply(message)}>
              <FaReply />
              <span>Reply</span>
            </div>
            <div className="menu_item" onClick={() => handleForward(message)}>
              <FaShare />
              <span>Forward</span>
            </div>
          </div>
        )}
      </div>
    );
  };

  // Filter rooms for forward modal
  const filteredRooms = getRoomList.filter(room =>
    room && room.name &&
    room.name.toLowerCase().includes(forwardSearchTerm.toLowerCase()) &&
    room.id !== liveRoom.id
  );

  // Debug logging
  console.log("getRoomList:", getRoomList);
  console.log("filteredRooms:", filteredRooms);
  console.log("forwardSearchTerm:", forwardSearchTerm);
  console.log("liveRoom.id:", liveRoom.id);


  return (
    <>
      <div className="chatroom_wrapper">
        <div className="chatroom_container">

          <div className="content_wrapper">
            <div className="room_list_container">
              <div className="title">
                <p>Rooms</p>
                <div className="notification_btn" onClick={() => setShowNotificationSettings(true)}>
                  {notificationsEnabled ? (
                    <BsBell className="notification_icon enabled" title="Notifications enabled - Click to manage" />
                  ) : (
                    <BsBellSlash className="notification_icon disabled" title="Notifications disabled - Click to enable" />
                  )}
                </div>
              </div>
              <ul className="room_list">
                {getRoomList.map((e) => {
                  return (
                    <li
                      className={activeRoom === e.id ? "activeRoom" : ""}
                      onClick={() => {
                        setLiveRoom({ ...e });
                        setActiveRoom(e.id);
                        get_chat_old(e.id);
                        // get_chat(e.id);
                      }}
                    >
                      <div className="room_identifier">
                        <div className="room_icon icon_theme_1" style={{ backgroundColor: uuidToHex(e.id) }}>
                          <p style={{ fontWeight: 900 }}>
                            {e.name
                              ?.split(" ")
                              .map((word) => word[0])
                              .join("")}
                          </p>
                        </div>
                        <div className="room_name">
                          <h4>{e.name}</h4>
                          {/* <p>Hey How's the project going? </p> */}
                        </div>
                        <div className="message_timing">
                          <div className="time">{/* <p>2:30PM</p> */}</div>
                          {getNotifyList[e.id] > 0 ? (
                            <div className="new_messages">
                              <p className="no_of_new_messages">
                                {getNotifyList[e.id]}
                              </p>
                            </div>
                          ) : (
                            <></>
                          )}
                        </div>
                      </div>
                    </li>
                  );
                })}
                {/* <li
                  className={
                    activeRoom === "GeneralDiscussion" ? "activeRoom" : ""
                  }
                  onClick={() => setActiveRoom("GeneralDiscussion")}
                >
                  <div className="room_identifier">
                    <div className="room_icon icon_theme_1">
                      <p>GD</p>
                    </div>
                    <div className="room_name">
                      <h4>General Discussion</h4>
                      <p>Hey How's the project going? </p>
                    </div>
                    <div className="message_timing">
                      <div className="time">
                        <p>2:30PM</p>
                      </div>
                      <div className="new_messages">
                        <p className="no_of_new_messages">3</p>
                      </div>
                    </div>
                  </div>
                </li> */}
              </ul>
            </div>
            <div className="room_content">
              {activeRoom != "" && (
                <>
                  <div className="room_metadata">
                    <div className="room_info" onClick={() => {
                      console.log('Room header clicked, opening members modal');
                      setShowMembersModal(true);
                    }} style={{ cursor: 'pointer' }}>
                      <div className="room_icon icon_theme_1">
                        <p>
                          {liveRoom.name
                            ?.split(" ")
                            .map((word) => word[0])
                            .join("")}
                        </p>
                      </div>
                      <div className="room_name">
                        <h4>{liveRoom.name}</h4>
                        <p>
                          <span className="member_count">
                            {liveRoom.member.length}
                          </span>
                          <span>members</span>
                        </p>
                      </div>
                    </div>
                    <div
                      className="close_room_container"
                      onClick={() => setActiveRoom("")}
                    >
                      <IoCloseOutline className="close_icon" />
                    </div>
                  </div>
                  <div
                    className="chat_content"
                    ref={divRef}
                    onScroll={handleScroll}
                  >


                    {getMessageListOld.map((e) => {
                      if (e.file == false) {
                        if (e.from == getId) {
                          return (
                            <div className={`chat_message sent ${e.reply_to ? 'is_reply' : ''} ${highlightedMessageId === e.id ? 'highlighted' : ''} ${isAnyUserTagged(e.data) ? 'user-tagged' : ''} ${isCurrentUserTagged(e.data) ? 'user-tagged-self' : ''}`} data-message-id={e.id}>
                              <div className="message_content">
                                <div className="message_header">
                                  {/* Reply Badge */}
                                  {e.reply_to && (
                                    <div className="reply_badge">
                                      <FaReply className="reply_badge_icon" />
                                      <span>Reply</span>
                                    </div>
                                  )}
                                  {/* Reply Count */}
                                  {(() => {
                                    const replyCount = getReplyCount(e.id);
                                    return replyCount > 0 && (
                                      <div className="reply_count_badge">
                                        <span>{replyCount} {replyCount === 1 ? 'reply' : 'replies'}</span>
                                      </div>
                                    );
                                  })()}
                                </div>
                                {renderEnhancedReplyIndicator(e)}
                                <div className="message_body">
                                  <p>{renderMessageWithTags(e.data, e.id)}</p>
                                </div>
                                <div className="message_time">
                                  <span>{formatTime(e.sent_at)}</span>
                                </div>
                              </div>
                              {renderEnhancedMessageActions(e)}
                            </div>
                          );
                        } else if (liveRoom.names[e.from]) {
                          return (
                            <div className={`chat_message received ${e.reply_to ? 'is_reply' : ''} ${highlightedMessageId === e.id ? 'highlighted' : ''} ${isAnyUserTagged(e.data) ? 'user-tagged' : ''} ${isCurrentUserTagged(e.data) ? 'user-tagged-self' : ''}`} data-message-id={e.id}>
                              <div className="message_container">
                                <div
                                  className="user_avatar"
                                  style={{ backgroundColor: `${uuidToHex(e.from)}` }}
                                >
                                  <p>
                                    {liveRoom.names[e.from]
                                      ?.split(" ")
                                      .map((word) => word[0])
                                      .join("")}
                                  </p>
                                </div>
                                <div className="message_content">
                                  <div className="sender_info_row">
                                    <div
                                      className="sender_name"
                                      style={{ color: `${uuidToHex(e.from)}` }}
                                    >
                                      <p>{liveRoom.names[e.from]}</p>
                                    </div>
                                    {/* Reply Badge */}
                                    {e.reply_to && (
                                      <div className="reply_badge">
                                        <FaReply className="reply_badge_icon" />
                                        <span>Reply</span>
                                      </div>
                                    )}
                                    {/* Reply Count */}
                                    {(() => {
                                      const replyCount = getReplyCount(e.id);
                                      return replyCount > 0 && (
                                        <div className="reply_count_badge">
                                          <span>{replyCount} {replyCount === 1 ? 'reply' : 'replies'}</span>
                                        </div>
                                      );
                                    })()}
                                  </div>

                                  {renderEnhancedReplyIndicator(e)}
                                  <div className="message_body">
                                    <p>{renderMessageWithTags(e.data, e.id)}</p>
                                  </div>
                                  <div className="message_time">
                                    <span>{formatTime(e.sent_at)}</span>
                                  </div>
                                </div>
                                {renderEnhancedMessageActions(e)}
                              </div>
                            </div>
                          );
                        } else {
                          return (
                            <div className={`chat_message received ${e.reply_to ? 'is_reply' : ''} ${highlightedMessageId === e.id ? 'highlighted' : ''} ${isAnyUserTagged(e.data) ? 'user-tagged' : ''} ${isCurrentUserTagged(e.data) ? 'user-tagged-self' : ''}`} data-message-id={e.id}>
                              <div className="message_container">
                                <div
                                  className="user_avatar"
                                  style={{
                                    backgroundColor: `${uuidToHex(e.from)}`,
                                  }}
                                >
                                  <p>A</p>
                                </div>
                                <div className="message_content">
                                  <div className="sender_info_row">
                                    <div
                                      className="sender_name"
                                      style={{ color: `${uuidToHex(e.from)}` }}
                                    >
                                      <p>ADMIN</p>
                                    </div>
                                    {/* Reply Badge */}
                                    {e.reply_to && (
                                      <div className="reply_badge">
                                        <FaReply className="reply_badge_icon" />
                                        <span>Reply</span>
                                      </div>
                                    )}
                                    {/* Reply Count */}
                                    {(() => {
                                      const replyCount = getReplyCount(e.id);
                                      return replyCount > 0 && (
                                        <div className="reply_count_badge">
                                          <span>{replyCount} {replyCount === 1 ? 'reply' : 'replies'}</span>
                                        </div>
                                      );
                                    })()}
                                  </div>

                                  {renderEnhancedReplyIndicator(e)}
                                  <div className="message_body">
                                    <p>{renderMessageWithTags(e.data, e.id)}</p>
                                  </div>
                                  <div className="message_time">
                                    <span>{formatTime(e.sent_at)}</span>
                                  </div>
                                </div>

                                {renderEnhancedMessageActions(e)}
                              </div>
                            </div>
                          );
                        }
                      } else if (e.file == true) {
                        if (e.from == getId) {
                          return (
                            <div className={`chat_message sent ${e.reply_to ? 'is_reply' : ''} ${highlightedMessageId === e.id ? 'highlighted' : ''} ${isAnyUserTagged(e.data) ? 'user-tagged' : ''} ${isCurrentUserTagged(e.data) ? 'user-tagged-self' : ''}`} data-message-id={e.id}>
                              <div className="message_content">
                                {/* Reply Badge */}
                                {e.reply_to && (
                                  <div className="reply_badge">
                                    <FaReply className="reply_badge_icon" />
                                    <span>Reply</span>
                                  </div>
                                )}
                                {renderEnhancedReplyIndicator(e)}
                                <div className="message_body">
                                  <div className="image_message">
                                    <div
                                      className="image_preview"
                                      onClick={() =>
                                        openImageModal(
                                          `data:image/${e.ext};base64, ${e.data}`
                                        )
                                      }
                                    >
                                      <img
                                        src={`data:image/${e.ext};base64, ${e.data}`}
                                        alt="Shared image"
                                        className="chat_image"
                                      />
                                      <div className="image_overlay">
                                        <span>Click to view full size</span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="message_time">
                                  <span>{formatTime(e.sent_at)}</span>
                                </div>
                              </div>
                              {renderEnhancedMessageActions(e)}
                            </div>
                          );
                        } else if (liveRoom.names[e.from]) {
                          return (
                            <div className={`chat_message received ${e.reply_to ? 'is_reply' : ''} ${highlightedMessageId === e.id ? 'highlighted' : ''} ${isAnyUserTagged(e.data) ? 'user-tagged' : ''} ${isCurrentUserTagged(e.data) ? 'user-tagged-self' : ''}`} data-message-id={e.id}>
                              <div className="message_container">
                                <div
                                  className="user_avatar"
                                  style={{ backgroundColor: `${uuidToHex(e.from)}` }}
                                >
                                  <p>
                                    {liveRoom.names[e.from]
                                      ?.split(" ")
                                      .map((word) => word[0])
                                      .join("")}
                                  </p>
                                </div>
                                <div className="message_content">
                                  <div className="sender_info_row">
                                    <div
                                      className="sender_name"
                                      style={{ color: `${uuidToHex(e.from)}` }}
                                    >
                                      <p>{liveRoom.names[e.from]}</p>
                                    </div>
                                    {/* Reply Badge */}
                                    {e.reply_to && (
                                      <div className="reply_badge">
                                        <FaReply className="reply_badge_icon" />
                                        <span>Reply</span>
                                      </div>
                                    )}
                                    {/* Reply Count */}
                                    {(() => {
                                      const replyCount = getReplyCount(e.id);
                                      return replyCount > 0 && (
                                        <div className="reply_count_badge">
                                          <span>{replyCount} {replyCount === 1 ? 'reply' : 'replies'}</span>
                                        </div>
                                      );
                                    })()}
                                  </div>

                                  {renderEnhancedReplyIndicator(e)}
                                  <div className="message_body">
                                    <div className="image_message">
                                      <div
                                        className="image_preview"
                                        onClick={() =>
                                          openImageModal(
                                            `data:image/${e.ext};base64, ${e.data}`
                                          )
                                        }
                                      >
                                        <img
                                          src={`data:image/${e.ext};base64, ${e.data}`}
                                          alt="Shared image"
                                          className="chat_image"
                                        />
                                        <div className="image_overlay">
                                          <span>Click to view full size</span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="message_time">
                                    <span>{formatTime(e.sent_at)}</span>
                                  </div>
                                </div>
                                {renderEnhancedMessageActions(e)}
                              </div>
                            </div>
                          );
                        } else {
                          return (
                            <div className={`chat_message received ${e.reply_to ? 'is_reply' : ''} ${highlightedMessageId === e.id ? 'highlighted' : ''} ${isAnyUserTagged(e.data) ? 'user-tagged' : ''} ${isCurrentUserTagged(e.data) ? 'user-tagged-self' : ''}`} data-message-id={e.id}>
                              <div className="message_container">
                                <div
                                  className="user_avatar"
                                  style={{
                                    backgroundColor: `${uuidToHex(e.from)}`,
                                  }}
                                >
                                  <p>A</p>
                                </div>
                                <div className="message_content">
                                  <div className="sender_info_row">
                                    <div
                                      className="sender_name"
                                      style={{ color: `${uuidToHex(e.from)}` }}
                                    >
                                      <p>ADMIN</p>
                                    </div>
                                    {/* Reply Badge */}
                                    {e.reply_to && (
                                      <div className="reply_badge">
                                        <FaReply className="reply_badge_icon" />
                                        <span>Reply</span>
                                      </div>
                                    )}
                                    {/* Reply Count */}
                                    {(() => {
                                      const replyCount = getReplyCount(e.id);
                                      return replyCount > 0 && (
                                        <div className="reply_count_badge">
                                          <span>{replyCount} {replyCount === 1 ? 'reply' : 'replies'}</span>
                                        </div>
                                      );
                                    })()}
                                  </div>

                                  {renderEnhancedReplyIndicator(e)}
                                  <div className="message_body">
                                    <div className="image_message">
                                      <div
                                        className="image_preview"
                                        onClick={() =>
                                          openImageModal(
                                            `data:image/${e.ext};base64, ${e.data}`
                                          )
                                        }
                                      >
                                        <img
                                          src={`data:image/${e.ext};base64, ${e.data}`}
                                          alt="Shared image"
                                          className="chat_image"
                                        />
                                        <div className="image_overlay">
                                          <span>Click to view full size</span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="message_time">
                                    <span>{formatTime(e.sent_at)}</span>
                                  </div>
                                </div>

                                {renderEnhancedMessageActions(e)}
                              </div>
                            </div>
                          );
                        }
                      }
                    })}

                  </div>

                  {/* Reply Preview */}
                  {replyingTo && (
                    <div className="reply_preview">
                      <div className="reply_preview_content">
                        <div className="reply_preview_header">
                          <FaReply className="reply_icon" />
                          <span>Replying to {liveRoom.names?.[replyingTo.from] || "ADMIN"}</span>
                          <button className="cancel_reply" onClick={cancelReply}>
                            <IoCloseOutline />
                          </button>
                        </div>
                        <div className="reply_preview_text">
                          {replyingTo.file ? "📷 Image" : replyingTo.data}
                        </div>
                      </div>
                    </div>
                  )}

                  <div className="send_message_container">
                    <div className="upload_file">
                      <input type="file"
                        id="file-input"
                        accept="image/*"
                        className="hidden"
                        onChange={(e) => {
                          select_file_upload(e);
                        }} />
                      <FaPlus
                        className="add_file_icon"
                        onClick={handleUploadClick}
                        title="Upload file"
                      />
                    </div>
                    <div className="text_input">
                      {getFileName == "" ? (
                        <div style={{ position: 'relative' }}>
                          <input
                            type="text"
                            placeholder="Type a message or paste an image..."
                            id="messagehere"
                            onKeyDown={(e) => {
                              if (e.key === 'Enter' && !showMentionSuggestions && activeRoom !== "") {
                                e.preventDefault();
                                console.log("Enter key pressed, attempting to send message");
                                send_message();
                              } else if (e.key === 'ArrowDown' && showMentionSuggestions) {
                                e.preventDefault();
                                // Focus first suggestion
                                const firstSuggestion = document.querySelector('.mention-suggestion-item');
                                if (firstSuggestion) firstSuggestion.focus();
                              } else if (e.key === 'Escape') {
                                setShowMentionSuggestions(false);
                                setMentionSearchTerm('');
                              }
                            }}
                            onInput={handleMentionInput}
                            onChange={handleMentionInput}
                          />
                          {showMentionSuggestions && mentionSuggestions.length > 0 && (
                            <div className="mention-suggestions-dropdown" style={{
                              position: 'absolute',
                              bottom: '100%',
                              left: '0',
                              right: '0',
                              backgroundColor: '#1e293b',
                              border: '1px solid #374151',
                              borderRadius: '8px',
                              boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
                              maxHeight: '200px',
                              overflowY: 'auto',
                              zIndex: 1000
                            }}>
                              {mentionSuggestions.map((suggestion, index) => (
                                <div
                                  key={suggestion.id}
                                  className="mention-suggestion-item"
                                  tabIndex={0}
                                  style={{
                                    padding: '8px 12px',
                                    cursor: 'pointer',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '8px',
                                    borderBottom: index < mentionSuggestions.length - 1 ? '1px solid #374151' : 'none'
                                  }}
                                  onClick={() => selectMention(suggestion)}
                                  onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                      selectMention(suggestion);
                                    } else if (e.key === 'ArrowDown') {
                                      e.preventDefault();
                                      const nextItem = e.target.nextElementSibling;
                                      if (nextItem) nextItem.focus();
                                    } else if (e.key === 'ArrowUp') {
                                      e.preventDefault();
                                      const prevItem = e.target.previousElementSibling;
                                      if (prevItem) prevItem.focus();
                                      else document.getElementById("messagehere").focus();
                                    }
                                  }}
                                  onMouseEnter={(e) => {
                                    e.target.style.backgroundColor = '#374151';
                                  }}
                                  onMouseLeave={(e) => {
                                    e.target.style.backgroundColor = 'transparent';
                                  }}
                                >
                                  <div
                                    style={{
                                      width: '32px',
                                      height: '32px',
                                      borderRadius: '50%',
                                      backgroundColor: uuidToHex(suggestion.id),
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      fontSize: '14px',
                                      fontWeight: '600',
                                      color: 'white'
                                    }}
                                  >
                                    {suggestion.name.split(" ").map(word => word[0]).join("")}
                                  </div>
                                  <div style={{ color: '#e2e8f0', fontSize: '14px' }}>
                                    {suggestion.name}
                                  </div>
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      ) : (
                        <div className="image_preview_container" style={{
                          position: 'relative',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '10px',
                          padding: '8px',
                          border: '1px solid #ddd',
                          borderRadius: '8px',
                          backgroundColor: '#f8f9fa'
                        }}>
                          <div className="image_preview_thumbnail" style={{
                            width: '40px',
                            height: '40px',
                            borderRadius: '4px',
                            overflow: 'hidden',
                            flexShrink: 0
                          }}>
                            <img
                              src={imagePreview}
                              alt="Preview"
                              style={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'cover'
                              }}
                            />
                          </div>
                          <div className="image_info" style={{
                            flex: 1,
                            minWidth: 0
                          }}>
                            <div style={{
                              fontSize: '14px',
                              fontWeight: '500',
                              color: '#333',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap'
                            }}>
                              {getFileName}
                            </div>
                            <div style={{
                              fontSize: '12px',
                              color: '#666',
                              marginTop: '2px'
                            }}>
                              {isImageSending ? 'Sending...' : 'Ready to send'}
                            </div>
                            {isImageSending && (
                              <div style={{
                                width: '100%',
                                height: '3px',
                                backgroundColor: '#e0e0e0',
                                borderRadius: '2px',
                                marginTop: '4px',
                                overflow: 'hidden'
                              }}>
                                <div style={{
                                  width: '100%',
                                  height: '100%',
                                  backgroundColor: '#007bff',
                                  borderRadius: '2px',
                                  animation: 'loadingBar 1.5s ease-in-out infinite'
                                }} />
                              </div>
                            )}
                          </div>
                          <button
                            className="clear_file_btn"
                            onClick={clearUploadedFile}
                            disabled={isImageSending}
                            title={isImageSending ? "Sending image..." : "Remove image"}
                            style={{
                              background: 'none',
                              border: 'none',
                              cursor: isImageSending ? 'not-allowed' : 'pointer',
                              fontSize: '18px',
                              color: isImageSending ? '#999' : '#dc3545',
                              fontWeight: 'bold',
                              transition: 'color 0.2s ease',
                              flexShrink: 0,
                              opacity: isImageSending ? 0.5 : 1
                            }}
                            onMouseEnter={(e) => e.target.style.color = '#c82333'}
                            onMouseLeave={(e) => e.target.style.color = '#dc3545'}
                          >
                            <IoCloseOutline />
                          </button>
                        </div>
                      )}
                    </div>
                    <div className="send_message">
                      <button
                        onClick={(e) => {
                          // Validate before sending
                          if (!activeRoom || activeRoom === "" || !liveRoom.id) {
                            alert("Please select a room before sending a message.");
                            return;
                          }
                          
                          const messageInput = document.getElementById("messagehere");
                          const messageText = messageInput ? messageInput.value : "";
                          if (getFileName === "" && messageText.trim() === "") {
                            alert("Please enter a message or select an image to send.");
                            return;
                          }
                          
                          send_message();
                        }}
                        disabled={!activeRoom || activeRoom === "" || isImageSending}
                        style={{
                          opacity: (!activeRoom || activeRoom === "" || isImageSending) ? 0.5 : 1,
                          cursor: (!activeRoom || activeRoom === "" || isImageSending) ? 'not-allowed' : 'pointer'
                        }}
                      >
                        <RiSendPlaneLine
                          className="send_icon"
                        />
                      </button>
                    </div>
                  </div>
                </>
              )}
              {activeRoom === "" && (
                <div className="default_screen">
                  <div className="default_content">
                    <p>ChatRoom for InterCommunication</p>
                    <span>Please select a room from the list on the left</span>
                  </div>
                </div>
              )}
            </div>
          </div>
          {selectedImage && (
            <div className="image_modal_overlay" onClick={closeImageModal}>
              <div className="image_modal" onClick={closeImageModal}>
                <div className="image_modal_header">
                  <button
                    className="image_modal_close"
                    onClick={(e) => {
                      e.stopPropagation();
                      closeImageModal();
                    }}
                    title="Close (ESC)"
                  >
                    <IoCloseCircle />
                  </button>
                </div>
                <div
                  className="image_modal_content"
                  onClick={closeImageModal}
                  onMouseMove={handleImageMouseMove}
                  onMouseUp={handleImageMouseUp}
                  onMouseLeave={handleImageMouseUp}
                  onWheel={handleImageWheel}
                >
                  <img
                    ref={imageModalRef}
                    src={selectedImage}
                    alt="Full size preview"
                    className={`full_size_image ${imageZoom > 1 ? 'zoomed' : ''}`}
                    style={{
                      transform: `translate(${imagePosition.x}px, ${imagePosition.y}px) scale(${imageZoom})`,
                      cursor: imageZoom > 1 ? (isDragging ? 'grabbing' : 'grab') : 'default',
                      transition: isDragging ? 'none' : 'transform 0.2s ease-out'
                    }}
                    onClick={(e) => e.stopPropagation()}
                    onMouseDown={handleImageMouseDown}
                    draggable={false}
                  />
                </div>
                <div className="zoom_controls" onClick={(e) => e.stopPropagation()}>
                  <button className="zoom_btn" onClick={(e) => { e.stopPropagation(); zoomOut(); }} title="Zoom Out">
                    -
                  </button>
                  <div className="zoom_info">{Math.round(imageZoom * 100)}%</div>
                  <button className="zoom_btn" onClick={(e) => { e.stopPropagation(); zoomIn(); }} title="Zoom In">
                    +
                  </button>
                  <button className="zoom_btn" onClick={(e) => { e.stopPropagation(); resetZoom(); }} title="Reset Zoom">
                    ⌂
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* Forward Modal */}
          {showForwardModal && (
            <div className="forward_modal_overlay" onClick={closeForwardModal}>
              <div className="forward_modal" onClick={(e) => e.stopPropagation()}>
                <div className="forward_modal_header">
                  <h3>Forward message to</h3>
                  <button className="forward_modal_close" onClick={closeForwardModal}>
                    <IoCloseOutline />
                  </button>
                </div>

                <div className="forward_search_container">
                  <div className="forward_search_box">
                    <IoSearch className="search_icon" />
                    <input
                      type="text"
                      placeholder="Search rooms..."
                      value={forwardSearchTerm}
                      onChange={(e) => setForwardSearchTerm(e.target.value)}
                    />
                  </div>
                </div>

                <div className="forward_rooms_list">
                  {filteredRooms.map((room) => (
                    <div
                      key={room.id}
                      className={`forward_room_item ${selectedForwardRooms.includes(room.id) ? "selected" : ""}`}
                      onClick={() => toggleRoomSelection(room.id)}
                    >
                      <div className="forward_room_info">
                        <div
                          className="forward_room_icon"
                          style={{ backgroundColor: uuidToHex(room.id) }}
                        >
                          <p>
                            {room.name
                              .split(" ")
                              .map((word) => word[0])
                              .join("")}
                          </p>
                        </div>
                        <div className="forward_room_name">
                          <h4>{room.name}</h4>
                        </div>
                      </div>
                      <div className="forward_room_checkbox">
                        <input
                          type="checkbox"
                          checked={selectedForwardRooms.includes(room.id)}
                          readOnly
                        />
                      </div>
                    </div>
                  ))}
                </div>

                <div className="forward_modal_footer">
                  <button
                    className="forward_cancel_btn"
                    onClick={closeForwardModal}
                  >
                    Cancel
                  </button>
                  <button
                    className="forward_send_btn"
                    onClick={handleForwardSend}
                    disabled={selectedForwardRooms.length === 0}
                  >
                    Forward ({selectedForwardRooms.length})
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* Members Modal */}
          {showMembersModal && (
            <div className="members_modal_overlay" onClick={() => setShowMembersModal(false)}>
              <div className="members_modal" onClick={(e) => e.stopPropagation()}>
                <div className="members_modal_header">
                  <h3>{liveRoom?.name} Members</h3>
                  <button
                    className="members_modal_close"
                    onClick={() => setShowMembersModal(false)}
                  >
                    <IoCloseOutline />
                  </button>
                </div>
                <div className="members_list">
                  <div className="members_count">{liveRoom?.member?.length || 0} members</div>
                  <div className="members_container">
                    {liveRoom?.member?.map((memberId) => {
                      console.log(liveRoom?.names, memberId);
                      const memberName = liveRoom?.names?.[memberId] || (memberId === 'admin' ? 'ADMIN' : (memberId === getId ? 'You' : 'Unknown User'));
                      const isCurrentUser = memberId === getId;
                      return (
                        <div key={memberId} className="member_item">
                          <div
                            className="member_avatar"
                            style={{ backgroundColor: uuidToHex(memberId) }}
                          >
                            <p>
                              {memberName
                                .split(" ")
                                .map((word) => word[0])
                                .join("")}
                            </p>
                          </div>
                          <div className="member_info">
                            <h4>{memberName}</h4>
                            {isCurrentUser && <span className="current_user_label">You</span>}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Notification Settings Modal */}
      <NotificationSettings
        isOpen={showNotificationSettings}
        onClose={() => setShowNotificationSettings(false)}
      />
    </>
  );
};

export default ChatRoom;
